<template>
    cus status
</template>

<script>

export default{
    data(){
        return {
            
        }
    }
}

</script>